import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

@Component({
  selector: 'app-datepicker-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="custom-header">
      <button
        type="button"
        class="nav-btn"
        (click)="previousMonth()"
        aria-label="Previous month"
      >
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none">
          <path d="M7.5 1.5L2.5 6.5L7.5 11.5" stroke="#999" stroke-width="1.5"/>
        </svg>
      </button>

      <span class="header-label">{{ periodLabel }}</span>

      <button
        type="button"
        class="nav-btn"
        (click)="nextMonth()"
        aria-label="Next month"
      >
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none">
          <path d="M0.5 1.5L5.5 6.5L0.5 11.5" stroke="#999" stroke-width="1.5"/>
        </svg>
      </button>
    </div>
  `,
  styles: [`
    .custom-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 12px 8px;
    }

    .nav-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      cursor: pointer;
      padding: 6px 10px;

      &:hover svg path {
        stroke: #333;
      }

      &:focus-visible {
        outline: 2px solid #830051;
        outline-offset: 2px;
      }
    }

    .header-label {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 700;
      color: #333;
      user-select: none;
    }
  `],
})
export class DatepickerHeaderComponent {
  private readonly calendar = inject(MatCalendar<Date>);
  private readonly dateAdapter = inject(DateAdapter<Date>);
  private readonly cdr = inject(ChangeDetectorRef);

  get periodLabel(): string {
    const month = MONTHS[this.dateAdapter.getMonth(this.calendar.activeDate)];
    const year = this.dateAdapter.getYear(this.calendar.activeDate);
    return `${month} ${year}`;
  }

  constructor() {
    this.calendar.stateChanges.subscribe(() => this.cdr.markForCheck());
  }

  previousMonth(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1);
  }

  nextMonth(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1);
  }
}
